/**
 * 叙事角色(`narrativeRoles`)→ 人读节拍标签(2026-08-10 导演台本上屏批)。
 *
 * ═══ 为什么要这一层 ══════════════════════════════════════════════════════════════
 * 导演每次编排都产 narrativeRoles(hook/build_tension/turn/resolution/cta,契约见 ai
 * `grid_detect` 导演 JSON spec),**但此前 UI 一处都没渲染** —— 节拍标注只在蓝图路
 * (`blueprint.beats`)点亮,普通编排路的用户看不到「这条片为什么这么讲」。
 * 本文件把角色枚举翻成人话,让分镜条/时间轴在无蓝图时也有结构轨。
 *
 * ★枚举值与 ai 侧导演契约逐字对应;未知值(历史草稿/引擎新档)返 null 不硬造 ——
 *   宁可这一镜没有标签,也不给它贴一个错的。
 */
export const NARRATIVE_ROLE_LABELS: Record<string, string> = {
  hook: "开场钩子",
  build_tension: "蓄势",
  turn: "转折",
  resolution: "收束",
  cta: "行动号召",
};

/** 单镜角色 → 标签;空/未知 → null(调用方按「没有标签」渲染)。 */
export function narrativeRoleLabel(role?: string | null): string | null {
  if (!role) return null;
  return NARRATIVE_ROLE_LABELS[role] ?? null;
}
